export default __webpack_public_path__ + "static/water_colour_credit-rgb-2d2764edd48cd216f272b9f79b96e1be.png";